module.exports = __webpack_public_path__ + "img/circle.37965b1f.svg";